module.exports = __webpack_public_path__ + "static/jordi-756c242900ca5afc486c9934174458b7.jpg";